import * as actions from './actions';

export type State = {
  selectedModalName: string;
  pageModel: any;
  headerHeight: number;
  footerHeight: number;
};

export default (
  state: State = { selectedModalName: '', pageModel: '', headerHeight: 0, footerHeight: 0 },
  action: any,
): State => {
  switch (action.type) {
    case actions.SHOW_MODAL:
      return {
        ...state,
        selectedModalName: action.payload,
      };
    case actions.HIDE_MODAL:
      return {
        ...state,
        selectedModalName: '',
        headerHeight: 0,
        footerHeight: 0,
      };
    case actions.SET_MODAL_CONTENT:
      return {
        ...state,
        pageModel: action.payload,
      };
    case actions.SET_MODAL_HEADER_HEIGHT:
      return {
        ...state,
        headerHeight: action.payload,
      };
    case actions.SET_MODAL_FOOTER_HEIGHT:
      return {
        ...state,
        footerHeight: action.payload,
      };
    default:
      return state;
  }
};
